var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.92,
    height: 52.48,
    viewBox: "0 0 45.92 52.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-html5",
    "data-name": "Icon simple-html5",
    d: "M2.25,0H48.17L43.993,47.151,25.16,52.48,6.433,47.149ZM17.624,21.32l-.507-5.943,22,.007.5-5.733L10.8,9.643l1.526,17.515H32.286l-.713,7.492L25.21,36.408l-6.462-1.771-.411-4.614H12.632l.722,9.121L25.21,42.314l11.762-3.155L38.6,21.322H17.624Z",
    transform: "translate(-2.25)",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5Logo);
export default __webpack_public_path__ + "static/media/html5-logo.73733f0e9dd8400cd83833fa58e3d744.svg";
export { ForwardRef as ReactComponent };